import PropTypes from 'prop-types';
import PurpleStarIcon from '../../../assets/svg/purple-star-20.svg?react';
import FJFaceSwapData from '../../../config/dataConfig/FJFaceSwapData';
import FJConfig from '../../../config/FJConfig';
import FJVersionConfig from '../../../config/FJVersionConfig';
import FJLocalStore from '../../../store/FJLocalStore';
import styles from './FJMobileFaceSwapPreset.module.less';
import FJLoading from '../../../common/components/FJLoading/FJLoading';

const FJMobileFaceSwapPreset = props => {
    const { onOriginTryThose, originCurLoadName } = props;

    return (
        <div className={styles.preset_box}>
            <div className={styles.preset_title}>
                <PurpleStarIcon />
                {FJLocalStore._('try-these-images')}
            </div>
            <div className={styles.preset_list}>
                {FJFaceSwapData.THOSE_ORIGIN_IMAGES.map(item => (
                    <div key={item.name} className={styles.preset_item}>
                        <img
                            key={item.name}
                            className={styles.preset_item_img}
                            onClick={() => onOriginTryThose(item)}
                            src={
                                FJConfig.thoseOriginImagesPath +
                                item.name +
                                '-min.png?v=' +
                                FJVersionConfig.staticPathVersion
                            }
                            alt=''
                        />
                        {originCurLoadName === item.name && (
                            <div className={styles.preset_item_loading}>
                                <FJLoading style={{ width: 16, height: 16 }} />
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};
FJMobileFaceSwapPreset.propTypes = {
    onOriginTryThose: PropTypes.func,
    originCurLoadName: PropTypes.string,
};
export default FJMobileFaceSwapPreset;
